import { render, staticRenderFns } from "./date-remind.vue?vue&type=template&id=4626c4d1&scoped=true&"
import script from "./date-remind.vue?vue&type=script&lang=js&"
export * from "./date-remind.vue?vue&type=script&lang=js&"
import style0 from "./date-remind.vue?vue&type=style&index=0&id=4626c4d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626c4d1",
  null
  
)

export default component.exports